import styles from './FullSizeLoader.module.scss';
import { Loader } from '@mantine/core';

export const FullSizeLoader = () => (
  <div className={styles.wrapper}>
    <div className={styles.loader}>
      <Loader />
    </div>
  </div>
);
